import React, { useEffect, useRef } from "react";
import { MdKeyboardArrowUp } from "@react-icons/all-files/md/MdKeyboardArrowUp";

import { useDispatch, useSelector } from "react-redux";
import { getNovelsPagination } from "../../../3- actions/novels";
import { useSearchParams } from "react-router-dom";

import Novel from "./Novel";
import NovelSkeleton from "./NovelSkeleton";
import NoData from "./NoData";
function NovelsPagination() {
  const dispatch = useDispatch();

  const novels = useSelector((state) => state.novelsData.novelsPagination);
  const skeleton = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

  const [page, setPage] = React.useState(1);
  const limit = 10;
  const myRef = useRef(null);

  const [searchParams] = useSearchParams();
  const search = searchParams.get("search") || "";
  const genre = searchParams.get("genre") || "";

  useEffect(() => {
    setPage(1);
  }, [genre, search]);

  useEffect(() => {
    if (page || genre || search) {
      dispatch(getNovelsPagination({ page, limit, search, genre }));
    }
  }, [page, genre, search]);

  return (
    <div ref={myRef} className="sm:mt-[80px] mt-[50px]">
      <div>
        {/* <Novel /> */}
        {novels?.pending ? (
          <div className="grid px-[15px] md:px-0 gap-4 sm:gap-8 md:gap-10 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 w-[100%] ">
            {skeleton?.map((novel, index) => {
              return (
                <div key={index}>
                  <NovelSkeleton novel={novel} />
                </div>
              );
            })}
          </div>
        ) : novels?.novels?.length === 0 ? (
          <div>
            <NoData />
          </div>
        ) : (
          <div className="grid px-[15px] md:px-0 gap-4 sm:gap-8 md:gap-10 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 w-[100%] ">
            {novels?.novels?.map((novel) => {
              return (
                <div key={novel._id}>
                  <Novel novel={novel} />
                </div>
              );
            })}
          </div>
        )}
      </div>
      {/* pagination */}
      {novels?.novels?.length !== 0 && (
        <div className="sm:mt-[30px] md:mt-[50px] pt-8 px-[15px] md:px-0">
          <div className="text-tertiary sm:text-[20px] text-[16px] flex  justify-center items-center gap-x-4 sm:gap-x-6 ">
            <span
              onClick={() => {
                setPage(1);
                myRef.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
              className={
                novels?.currentPage === 1
                  ? "cursor-pointer pointer-events-none hidden relative Purple-btn-effect  hover:bg-primary/90 duration-500 ease-in-out sm:h-[52px] h-[52px] sm:w-[52px] w-full  font-SoraR justify-center items-center bg-primary "
                  : "cursor-pointer flex opacity-100 relative Purple-btn-effect  hover:bg-primary/90 duration-500 ease-in-out sm:h-[52px] h-[52px] sm:w-[52px] w-full  font-SoraR justify-center items-center bg-primary "
              }
            >
              <MdKeyboardArrowUp className="-rotate-90 scale-150" />
            </span>
            <span
              onClick={() => {
                setPage((prev) => prev - 1);
                myRef.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
              className={
                novels?.currentPage === 1
                  ? "cursor-pointer pointer-events-none opacity-50 relative Purple-btn-effect hover:bg-primary/90 duration-500 ease-in-out sm:h-[52px] h-[52px] sm:w-[52px] w-full flex font-SoraR justify-center items-center bg-primary"
                  : page === novels?.numberOfPages
                  ? "cursor-pointer  hover:opacity-100 opacity-100 relative Purple-btn-effect hover:bg-primary/90 duration-500 ease-in-out sm:h-[52px] h-[52px] sm:w-[52px] w-full flex font-SoraR justify-center items-center bg-primary"
                  : "cursor-pointer  hover:opacity-100 opacity-50 relative Purple-btn-effect hover:bg-primary/90 duration-500 ease-in-out sm:h-[52px] h-[52px] sm:w-[52px] w-full flex font-SoraR justify-center items-center bg-primary"
              }
            >
              {novels?.currentPage === novels?.numberOfPages
                ? novels?.currentPage
                : novels?.currentPage}
            </span>
            <span
              onClick={() => {
                setPage((prev) => prev + 1);
                myRef.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
              className={
                novels?.currentPage === novels?.numberOfPages
                  ? "cursor-pointer pointer-events-none opacity-50 flex relative Purple-btn-effect hover:bg-primary/90 duration-500 ease-in-out sm:h-[52px] h-[52px] sm:w-[52px] w-full font-SoraR justify-center items-center bg-primary "
                  : "cursor-pointer relative Purple-btn-effect hover:bg-primary/90 duration-500 ease-in-out sm:h-[52px] h-[52px] sm:w-[52px] w-full flex font-SoraR justify-center items-center bg-primary "
              }
            >
              {novels?.currentPage === novels?.numberOfPages
                ? "--"
                : novels?.currentPage + 1}
            </span>

            <span
              onClick={() => {
                setPage(novels?.numberOfPages);
                myRef.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
              className={
                novels?.currentPage === novels?.numberOfPages
                  ? "cursor-pointer hidden relative Purple-btn-effect  hover:bg-primary/90 duration-500 ease-in-out sm:h-[52px] h-[52px] sm:w-[52px] w-full  font-SoraR justify-center items-center bg-primary "
                  : "cursor-pointer relative Purple-btn-effect  hover:bg-primary/90 duration-500 ease-in-out sm:h-[52px] h-[52px] sm:w-[52px] w-full flex font-SoraR justify-center items-center bg-primary "
              }
            >
              <MdKeyboardArrowUp className="rotate-90 scale-150" />
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default NovelsPagination;
